interface StructuredDataProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
  articleData?: {
    headline: string;
    description: string;
    image: string;
    datePublished: string;
    dateModified: string;
    authorName: string;
  };
  faqData?: Array<{ question: string; answer: string }>;
}

export default function StructuredData({ type, data, articleData, faqData }: StructuredDataProps) {
  let schema: Record<string, unknown>;

  switch (type) {
    case 'Organization':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '樱花动漫91',
        url: 'https://yinghuadongman91.com',
        description: '樱花动漫91提供漫画全集下拉式阅读体验，海量在线漫画资源，好看的漫画免费看，每日更新最新漫画章节。',
        ...data,
      };
      break;
    case 'WebSite':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '樱花动漫91',
        url: 'https://yinghuadongman91.com',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://yinghuadongman91.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
        ...data,
      };
      break;
    case 'WebPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        ...data,
      };
      break;
    case 'Article':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: articleData?.headline,
        description: articleData?.description,
        image: articleData?.image,
        datePublished: articleData?.datePublished,
        dateModified: articleData?.dateModified,
        author: {
          '@type': 'Person',
          name: articleData?.authorName,
        },
        publisher: {
          '@type': 'Organization',
          name: '樱花动漫91',
        },
        ...data,
      };
      break;
    case 'FAQPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqData?.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        })),
        ...data,
      };
      break;
    default:
      schema = {};
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}